import { EntityMetadataBuilder, PropertyType } from "clavis-nxt-components-custdevtm";

const METADATA = new EntityMetadataBuilder("ConfigurationEntity")
    .entityPath("configuration")
    .createProperty("id")
    .propertyType(PropertyType.NUMBER)
    .id()
    .finish()
    .createProperty("confKey")
    .propertyType(PropertyType.STRING)
    .finish()
    .createProperty("confValue")
    .propertyType(PropertyType.STRING)
    .finish()
    .createProperty("confDesc")
    .propertyType(PropertyType.STRING)
    .finish()
    .createProperty("moduleCode")
    .propertyType(PropertyType.STRING)
    .finish()
    .build();

export default METADATA;
